import { TRAINERS } from "../content";
import Reveal from "./Reveal";

export default function Trainers() {
  return (
    <section id="prowadzace" className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <h2 className="text-2xl font-bold lowercase tracking-tight text-[#242344] sm:text-3xl lg:text-4xl">
            poznaj nasze prelegentki
          </h2>
        </Reveal>
        <div className="mt-10 grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-3 lg:grid-cols-4">
          {TRAINERS.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.06}>
              <figure
                data-testid={`instructor-card-${t.id}`}
                className="group h-full rounded-2xl border border-[#EAE6F0] bg-white p-3 pb-5 transition-all duration-200 hover:-translate-y-1 hover:border-[#FFB3DA] hover:shadow-xl hover:shadow-[#FF008B]/5"
              >
                <div className="overflow-hidden rounded-xl bg-[#FAF8FC]">
                  <img
                    src={t.photo}
                    alt={`Zdjęcie: ${t.name}`}
                    loading="lazy"
                    width="768"
                    height="768"
                    className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                </div>
                <figcaption className="mt-4 px-1 text-center text-sm font-bold text-[#242344] sm:text-base">
                  {t.name}
                </figcaption>
              </figure>
            </Reveal>
          ))}
          <Reveal delay={0.45}>
            <div className="flex h-full min-h-[10rem] flex-col items-center justify-center rounded-2xl bg-[#FDF4F8] p-6 text-center">
              <p className="text-4xl font-extrabold text-[#FF008B]">7</p>
              <p className="mt-1 text-sm font-bold text-[#242344]">trenerek i ekspertek</p>
              <p className="mt-1 text-xs text-[#68677A]">15 modułów · 69 lekcji</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
